import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  ImageInput,
  ImageField,
  BooleanInput,
  translate
} from "admin-on-rest";
import DateInput from "../../../components/DateInput";
import RichTextInput from "aor-rich-text-input";
import {validateGameTipData} from "./validations";
import {connect} from "react-redux";
import {formStyle} from "./style";

const GameTipTitleBase = ({record, translate}) => {
  return (
    <span>
      {translate("resources.gametips.titleEdit")}{" "}
      {record ? `"${record.title}"` : ""}
    </span>
  );
};

const GameTipTitle = translate(GameTipTitleBase);

let DateTimeFormat;
DateTimeFormat = global.Intl.DateTimeFormat;

class GameTipEditFormBase extends React.Component {
  componentDidMount() {
    if (this.props.configuration && this.props.configuration.speltips) {
      const {history} = this.props;
      if (this.props.configuration.speltips.enabled !== true)
        history.replace(`/`);
    }
  }

  componentDidUpdate(nextProps) {
    if (this.props.configuration !== nextProps.configuration) {
      const {history} = this.props;
      if (this.props.configuration.speltips.enabled !== true)
        history.replace(`/`);
    }
  }

  render() {
    const props = {...this.props};
    const reduxErrors = {...props.errors};
    const errors = {...reduxErrors.syncErrors};
    return (
      <Edit title={<GameTipTitle />} {...props}>
        <SimpleForm validate={validateGameTipData}>
          <ImageInput
            source="images"
            label="resources.gametips.inputs.articleImage"
            accept="image/*"
          >
            <ImageField source="src" title="title" />
          </ImageInput>
          {(reduxErrors.anyTouched || reduxErrors.submitFailed) &&
            errors.images && (
              <span style={formStyle.validationStyle}>
                {props.translate("resources.gametips.validation.images")}
              </span>
            )}
          <TextInput label="resources.gametips.inputs.title" source="title" />
          <TextInput label="resources.gametips.inputs.author" source="author" />
          <DateInput
            label="resources.gametips.inputs.date"
            source="date"
            options={{
              locale: "sv",
              DateTimeFormat: Intl.DateTimeFormat,
              formatDate: new DateTimeFormat("sv", {
                day: "numeric",
                month: "long",
                year: "numeric"
              }).format
            }}
            hideCalendarDate={true}
            style={formStyle.containerInput}
            textFieldStyle={formStyle.dateInput.textFieldStyle}
            customInputStyle={formStyle.dateInput.customInputStyle}
          />

          <BooleanInput
            label="resources.gametips.inputs.published"
            source="published"
          />
          <RichTextInput source="content" addLabel={false} />
          {(reduxErrors.anyTouched || reduxErrors.submitFailed) &&
            errors.content && (
              <span style={formStyle.validationStyle}>
                {props.translate("resources.gametips.validation.content")}
              </span>
            )}
        </SimpleForm>
      </Edit>
    );
  }
}

const mapStateToProps = state => {
  return {
    errors: state.form[`record-form`],
    configuration: state.configuration
  };
};

const GameTipEditForm = connect(mapStateToProps)(
  translate(GameTipEditFormBase)
);

export default GameTipEditForm;



// WEBPACK FOOTER //
// ./src/containers/CRM/GameTips/GameTipEditForm.js